import { Routes } from '@angular/router';

const title = 'Reportes';
const data = { title, isShowBreadcrumb: true };

export const ROUTES: Routes = [
  {
    path: 'reporte-usuario',
    children: [
      {
        path: '',
        title,
        data: { ...data, urls: [{ title: 'Usuarios' }] },
        loadComponent: () => import('./pages/reporte-usuario-lista/reporte-usuario-lista.component'),
      },
    ],
  },
  {
    path: 'reporte-mascota',
    children: [
      {
        path: '',
        title,
        data: { ...data, urls: [{ title: 'Mascotas' }] },
        loadComponent: () => import('./pages/reporte-mascota-lista/reporte-mascota-lista.component'),
      },
    ],
  },
  {
    path: 'reporte-perdida',
    children: [
      {
        path: '',
        title,
        data: { ...data, urls: [{ title: 'Pérdidas' }] },
        loadComponent: () => import('./pages/reporte-perdido-lista/reporte-perdido-lista.component'),
      },
    ],
  },
  {
    path: 'reporte-adopcion',
    children: [
      {
        path: '',
        title,
        data: { ...data, urls: [{ title: 'Adopciones' }] },
        loadComponent: () => import('./pages/reporte-adopcion-lista/reporte-adopcion-lista.component'),
      },
    ],
  },
  {
    path: 'reporte-encontrado',
    children: [
      {
        path: '',
        title,
        data: { ...data, urls: [{ title: 'Encontrados' }] },
        loadComponent: () => import('./pages/reporte-encontrada-lista/reporte-encontrada-lista.component'),
      },
    ],
  },
  {
    path: 'reporte-pareja',
    children: [
      {
        path: '',
        title,
        data: { ...data, urls: [{ title: 'Parejas' }] },
        loadComponent: () => import('./pages/reporte-match-lista/reporte-match-lista.component'),
      },
    ],
  },
{
    path: 'reporte-recordatorio',
    children: [
      {
        path: '',
        title,
        data: { ...data, urls: [{ title: 'Recordatorios' }] },
        loadComponent: () => import('./pages/reporte-tranzabilidad-lista/reporte-tranzabilidad-lista.component'),
      },
    ],
  },
];
